import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { AppLoadService, IContact, IUser } from '@ebb-v2/ebb-integration';

@Injectable({ providedIn: 'root' })
export class CrossSiteNavigationService {
    constructor(
        private authenticationService: AuthenticationService,
        private appLoadService: AppLoadService) {

        }

        public ebbSiteUrl(relativePath: string, user: IUser) : string {
            if(this.appLoadService.readEnvironSettings().originSiteRoot !== this.appLoadService.readEnvironSettings().ebbSiteRoot) {
                return this.authenticationService.loginCrossSiteUser(this.appLoadService.readEnvironSettings().ebbApi, user.email, `${this.appLoadService.readEnvironSettings().ebbSiteRoot}${relativePath}`);
            }
    
            return relativePath;
        }
    
        public essSiteUrl(relativePath: string, user: IUser) : string {
            if(this.appLoadService.readEnvironSettings().originSiteRoot !== this.appLoadService.readEnvironSettings().essSiteRoot)  {
                return this.authenticationService.loginCrossSiteUser(this.appLoadService.readEnvironSettings().essApi, user.email, `${this.appLoadService.readEnvironSettings().essSiteRoot}${relativePath}`);
            }
    
            return relativePath;
        }

}